module.exports = __webpack_public_path__ + "images/花筑pr长图_04-6.jpg?v=cab5c648";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_04-6.jpg
 ** module id = 19
 ** module chunks = 1 2
 **/